// React
import { useHistory, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containeirs Injections
import { SellersInjection } from '../../containers/sellersInjection';

// View
import { SellersFormPage } from './view';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import '../../../../utils/validation/cpfMethodValidation';
import { APIClient } from '../../../../helpers/api_helper';

export const SellersForm = () => {
  const [seller, setSeller] = useState(null);

  const { offices, getOffices, createSellers, updateSellers, successOffices } =
    SellersInjection();

  const { id } = useParams();
  const api = new APIClient();
  const history = useHistory();
  const { loadingWithTime } = useLoading();

  const getSellersById = async (id) => {
    const sellerFound = await api.get(`/register/seller/${id}`);

    if (sellerFound) {
      setSeller(sellerFound);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      nameInput: seller ? seller.name : '',
      cpfInput: seller ? seller.cpf : '',
      rgInput: seller ? seller.rg : '',
      orgaoInput: seller ? seller.rg_issuer : '',
      birthdayInput: seller ? seller.birthdate : '',
      genderInput: seller && seller.gender === 'M' ? 'M' : 'F',
      stateCivilInput:
        seller && seller.marital_status_id
          ? {
              label: seller.marital_status_name,
              value: seller.marital_status_id,
            }
          : {
              label: '',
              value: '',
            },
      emailInput: seller ? seller.email : '',
      phoneInput: seller ? seller.phone1 : '',
      telInput: seller ? seller.phone2 : '',
      zipInput: seller ? seller.zipcode : '',
      streetInput: seller ? seller.address1 : '',
      numberInput: seller ? seller.address_number : '',
      address2Input: seller ? seller.address2 : '',
      neighborhoodInput: seller ? seller.district : '',
      cityInput:
        seller && seller.city_id
          ? {
              label: seller.city_name,
              value: seller.city_id,
            }
          : {
              label: '',
              value: '',
            },
      pointInput: seller ? seller.reference_point : '',
      isActiveSelect: seller ? seller.active : false,
      officeInput:
        seller && seller.office_id
          ? {
              label: seller.office_name,
              value: seller.office_id,
            }
          : {
              label: '',
              value: '',
            },
    },

    validationSchema: Yup.object({
      nameInput: Yup.string().required('Nome é obrigatório'),
      cpfInput: Yup.string().cpfType('Digite um CPF válido'),
      birthdayInput: Yup.date(),
      phoneInput: Yup.string().nullable(),
      zipInput: Yup.string().nullable(),
      streetInput: Yup.string().nullable(),
      numberInput: Yup.string().nullable(),
      neighborhoodInput: Yup.string().nullable(),
      cityInput: Yup.object().nullable(),
      rgInput: Yup.string().nullable(),
      orgaoInput: Yup.string().nullable(),
      genderInput: Yup.string().nullable(),
      stateCivilInput: Yup.object().nullable(),
      jobInput: Yup.string().nullable(),
      obsInput: Yup.string().nullable(),
      emailInput: Yup.string()
        .nullable()
        .required('Email é obrigatório')
        .email('Email inválido'),
      telInput: Yup.string().nullable().nullable(),
      whatsappInput: Yup.string().nullable(),
      address2Input: Yup.string().nullable().nullable(),
      pointInput: Yup.string().nullable(),
      isActiveSelect: Yup.boolean().nullable(),
      officeInput: Yup.object().nullable().required('Selecione um escritório'),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        name: values.nameInput || null,
        cpf: values.cpfInput || null,
        rg: values.rgInput || null,
        rg_issuer: values.orgaoInput || null,
        marital_status_id: values.stateCivilInput.value,
        birthdate: values.birthdayInput || null,
        gender: values.genderInput,
        profession: values.jobInput || null,
        email: values.emailInput || null,
        address1: values.streetInput || null,
        address2: values.address2Input || null,
        whatsapp: null,
        address_number: values.numberInput || null,
        reference_point: values.pointInput || null,
        district: values.neighborhoodInput || null,
        city_id: values.cityInput.value || null,
        zipcode: values.zipInput || null,
        obs: values.obsInput || null,
        photo: values.photoImage || null,
        active: values.isActiveSelect,
        phone1: values.phoneInput || null,
        phone2: values.telInput || null,
        office_id: values.officeInput.value || null,
      };

      loadingWithTime(1000);
      if (id) {
        updateSellers(seller.id, { ...valuesToSubmit, id: seller.id });
        history.goBack();
      } else {
        createSellers(valuesToSubmit);
        history.goBack();
      }
    },
  });

  useEffect(() => {
    getOffices();
  }, [successOffices]);

  useEffect(() => {
    if (id) {
      getSellersById(id);
    }
  }, [id]);

  return (
    <SellersFormPage
      id={id}
      history={history}
      validation={validation}
      offices={offices || []}
      updatedAt={seller && seller.last_update}
    />
  );
};
